import { Component, Input } from '@angular/core';

import { WysiwygSectionCms } from '~/cms/interfaces/homepage.cms.interface';

@Component({
  selector: 'app-cms-wysiwyg-section',
  templateUrl: './wysiwyg-section.component.html',
})
export class CmsWysiwygSectionComponent {
  @Input() public section: WysiwygSectionCms;
}
